const handleSetArrayParam = (params: string[] = [], key: string) => {
  return params && params.length && { [key]: '[' + params.toString() + ']' };
};

export default handleSetArrayParam;
